import axios from 'axios';
import store from '../store';

function getLibrary (clientId) {
  return axios.get('api/client/' + clientId + '/library/');
}

function getLibraryAndValidate (clientId) {
  return axios.get('api/client/' + clientId + '/library/validate')
    .then((response) => {
      store.dispatch('library/isValidatingOff');
      store.dispatch('library/setValidationResults', response.data);
    });
}

function getLibraryForTour (clientId, tourId) {
  return axios.get('api/client/' + clientId + '/library/tour/' + tourId);
}

function getSignedUrlForLibraryItem (clientId, libraryItemId) {
  return axios.get('api/client/' + clientId + '/library/media/' + libraryItemId + '/signedUrl');
}

function getAssignableMediaForTour (clientId, tourId, type) {
  return axios.get('api/client/' + clientId + '/library/tour/' + tourId + '/media/' + type);
}

function getStoryMediaForTour (data) {
  return axios.get('api/client/' + data.clientId + '/library/story/tour/' + data.tourId + '/topic/' + data.topicId + '/currentRouteId/' + data.currentRouteID);
}

function deleteLibraryItem (clientId, libraryId) {
  return axios.delete('api/client/' + clientId + '/library/media/' + libraryId);
}

function deleteLibraryItemMultiple (clientId, libraryId) {
  return axios.post('api/client/' + clientId + '/library/mediaMutiple/', libraryId);
}

function addTourMedia (data) {
  return axios.post('api/client/' + data.clientId + '/library/tour/' + data.tourId, data);
}

function removeTourMedia (data) {
  return axios.post('api/client/' + data.clientId + '/library/tour/' + data.tourId + '/remove', data);
}

function getNotificationsForTour (tourId, clientId) {
  return axios.get('api/client/' + clientId + '/library/tour/' + tourId + '/notifications');
}

function addFileWithRouteApi () {
  let clientId = store.state.client.currentClient.id;
  return axios.get('api/client/' + clientId + '/addFileWithRouteApi');
}

function addLibraryFileToRouteApi (libraryID) {
  let clientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + clientId + '/addLibraryFileToRouteApi', libraryID);
}

function updatePriorityLibraryStory (data) {
  return axios.post('api/client/updatePriorityLibraryStory', data);
}

function updatePriorityForTourMedia (data) {
  return axios.post('api/client/updatePriorityTourMedia', data);
}

function updatePriorityForTopicROute (data) {
  return axios.post('api/client/updatePriorityForTopicROute', data);
}

export {
  addTourMedia,
  deleteLibraryItemMultiple,
  deleteLibraryItem,
  getAssignableMediaForTour,
  getLibrary,
  getLibraryAndValidate,
  getLibraryForTour,
  getSignedUrlForLibraryItem,
  getStoryMediaForTour,
  removeTourMedia,
  getNotificationsForTour,
  updatePriorityLibraryStory,
  updatePriorityForTourMedia,
  addFileWithRouteApi,
  addLibraryFileToRouteApi,
  updatePriorityForTopicROute
};



// WEBPACK FOOTER //
// ./src/services/LibraryService.js